import React, { useState } from 'react'
import { UPDATE_FORM_BUILDER_BY_FORM_STRING_ID } from '../../../../graphql/mutation'
import { useMutation } from '@apollo/client'
import { GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID } from '../../../../graphql/query'
import { toast } from 'react-toastify'

interface IProps {
  formInfo: any
  closeExpiryModal: () => void
}

const ExpiryDateModal: React.FC<IProps> = ({ closeExpiryModal, formInfo }) => {
  const [expiryDate, setExpiryDate] = useState<any>()
  const [updateFormExpiry] = useMutation(UPDATE_FORM_BUILDER_BY_FORM_STRING_ID, {
    refetchQueries: [
      {
        query: GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID,
        variables: {
          input: {
            formUuid: null
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Form-Builder'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })
  console.log(formInfo)
  const updateExpiryDate = async () => {
    try {
      const inputRes = await updateFormExpiry({
        variables: {
          input: {
            formUuid: formInfo.formUuid,
            expiryDate: expiryDate,
            featuresToUpdate: {
              name: formInfo.name
            }
          }
        }
      })

      closeExpiryModal()
      if (inputRes.data.updateFormBuilderByFormStringId.message) {
        toast.success(inputRes.data.updateFormBuilderByFormStringId.message)
      } else {
        toast.error('Failed to update the changes.')
      }
    } catch (err) {
      toast.error('Sorry! Unexpected Error.')
      console.error(err)
    }
  }

  return (
    <div className='d-flex justify-content-center align-items-center'>
      <div className='card w-500px'>
        <div className='mb-4'>
          <h1 className='text-center'>Update Expiry Date</h1>
        </div>
        <div className='card-body py-0'>
          <div className='mb-3'>
            <label htmlFor='expiry-date' className='form-label'>
              Expiry Date:
            </label>
            <input
              type='date'
              className='form-control'
              id='expiry-date'
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
            />
          </div>
          <div className='d-flex justify-content-end mt-4'>
            <button className='btn btn-secondary me-2' onClick={closeExpiryModal}>
              Cancel
            </button>
            <button className='btn btn-primary' onClick={updateExpiryDate}>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExpiryDateModal
